import { render, staticRenderFns } from "./AddPush.vue?vue&type=template&id=3754f3d6&"
import script from "./AddPush.vue?vue&type=script&lang=js&"
export * from "./AddPush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports